//@flow
export const ENTITY_TABLE_ID = 'VehicleMaster';
export const ENTITY_EXPORT_ID = 'VEHICLE_MASTER';
export const ENTITY_NAME_ID = 'masterVehicle';
export const ENTITY_TYPE = 'VEHICLE';
